const SiteSearch = () => {
  const searchBtn = document.querySelector(".site-search__btn");
  const curtain = document.querySelector(".site-search__curtain");
  const searchInput = document.querySelector(".site-search__search input");

  const searchOn = () => {
    document.documentElement.classList.add("search-active", "scroll-auto");
    setTimeout(() => {
      searchInput.focus();
    }, 300);
  };

  const searchOff = () => {
    document.documentElement.classList.remove("search-active", "scroll-auto");
  };

  searchBtn.addEventListener("click", () => {
    searchOn();
  });

  curtain.addEventListener("click", () => {
    searchOff();
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      searchOff();
    }
  });
};
export default SiteSearch;
